const CommissionPayment = { data: [], loading: true };
export const GetComPaymentReportRed = (state = CommissionPayment, action) => {
  switch (action.type) {
    case "get_allcompaymentreport":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

const initialState = {
  commissionPayments: [],
};

export const commissionPaymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_COMMISSION_PAYMENTS_DATA":
      return {
        ...state,
        commissionPayments: action.payload,
      };
    default:
      return state;
  }
};
